import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.promise.js";
import AuthService from "../services/auth.service";
var user = JSON.parse(localStorage.getItem('user'));
var initialState = user ? {
  status: {
    loggedIn: true
  },
  user: user
} : {
  status: {
    loggedIn: false
  },
  user: null
};
export var auth = {
  namespaced: true,
  state: initialState,
  actions: {
    login: function login(_ref, user) {
      var commit = _ref.commit;
      return AuthService.login(user).then(function (user) {
        commit('loginSuccess', user);
        return Promise.resolve(user);
      }, function (error) {
        commit('loginFailure');
        return Promise.reject(error);
      });
    },
    logout: function logout(_ref2) {
      var commit = _ref2.commit;
      AuthService.logout();
      commit('logout');
    },
    register: function register(_ref3, user) {
      var commit = _ref3.commit;
      return AuthService.register(user).then(function (response) {
        commit('registerSuccess');
        return Promise.resolve(response.data);
      }, function (error) {
        commit('registerFailure');
        return Promise.reject(error);
      });
    }
  },
  mutations: {
    loginSuccess: function loginSuccess(state, user) {
      state.status.loggedIn = true;
      state.user = user;
    },
    loginFailure: function loginFailure(state) {
      state.status.loggedIn = false;
      state.user = null;
    },
    logout: function logout(state) {
      state.status.loggedIn = false;
      state.user = null;
    },
    registerSuccess: function registerSuccess(state) {
      state.status.loggedIn = false;
    },
    registerFailure: function registerFailure(state) {
      state.status.loggedIn = false;
    }
  }
};